var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-content"},[_c('div',[_c('i',{class:_vm.getMenuIcon(_vm.menuType)}),_c('h2',[_vm._v(_vm._s(_vm.menuTitle)+"内容区域")]),_c('p',[_vm._v("这里将显示"+_vm._s(_vm.menuTitle)+"的相关信息")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }